import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "menu-select",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
import { tree } from '@/api/system/menu';
import { MENU_STYLE } from '@/constant/system/code';
import { ElSelect } from 'element-plus';
import 'element-plus/es/components/select/style/css'


import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MenuSelect',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var selectRef = ref();
    var data = ref([]);
    var defaultProps = {
      children: 'children',
      label: 'menuName'
    };
    /**
     * 将树结构转化为选项
     */
    var selectOption = computed(function () {
      var option = [];
      function getChildren(data) {
        data.forEach(function (item) {
          option.push({
            label: item.menuName,
            value: item.id
          });
          if (item.children) {
            getChildren(item.children);
          }
        });
      }
      getChildren(data.value);
      return option;
    });
    var selectValue = computed({
      get: function get() {
        if (selectOption.value.length === 0) {
          return '';
        }
        return prop.modelValue;
      },
      set: function set(newVal) {
        emit('update:modelValue', newVal);
      }
    });
    tree().then(function (result) {
      data.value = filterDirectoryNode(result.data);
    });
    /**
     * 过滤目录节点
     * @param data 全部节点
     */
    function filterDirectoryNode(data) {
      var res = data.filter(function (item) {
        return item.menuStyle === MENU_STYLE.CATALOG;
      });
      res.forEach(function (item) {
        if (item.children) {
          item.children = filterDirectoryNode(item.children);
        }
      });
      return res;
    }
    /**
     * 节点点击
     * @param e 事件
     */
    function nodeClick(e) {
      var _selectRef$value;
      selectValue.value = e.id;
      (_selectRef$value = selectRef.value) === null || _selectRef$value === void 0 || _selectRef$value.blur();
      // selectRef.value?.handleClose()
    }
    return function (_ctx, _cache) {
      var _component_el_tree = _resolveComponent("el-tree");
      var _component_el_option = _resolveComponent("el-option");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElSelect), {
        modelValue: _unref(selectValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(selectValue) ? selectValue.value = $event : null;
        }),
        placeholder: "请选择目录",
        style: {
          "width": "100%",
          "height": "100%"
        },
        ref_key: "selectRef",
        ref: selectRef
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_option, {
            style: {
              "height": "auto",
              "background": "white",
              "padding": "0"
            },
            value: "tree-select-option",
            label: "tree-select-option",
            disabled: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tree, {
                data: _unref(data),
                props: defaultProps,
                onNodeClick: nodeClick
              }, null, 8, ["data"])];
            }),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOption), function (item, index) {
            return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])), [[_vShow, false]]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});